import { Context } from "@nuxt/types";
import { auth } from "~/setups/firebase";
import { onAuthStateChanged, User } from "firebase/auth";

export default function ({ store }: Context) {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      unsubscribe()
      if (user) {
        await user.getIdToken()

        await store.dispatch("auth/setUser", user)
      }

      resolve(null)
    })
  });
}
